<template>
    <div>
        <SubHeader :text="$t('h.Support')" :imgUrl="img" />
        <div class="bg" :style="lang === 'en_US' ? st : st1">
            <div class="cont">
                <h3 class="cont-title reveal-bottom">{{ $t("sp.so") }}</h3>
                <div class="cont-text reveal-bottom">
                    {{ $t("sp.soc") }}<br />
                    {{ $t("sp.soc1") }}<br />
                    {{ $t("sp.soc2") }}<br />
                    {{ $t("sp.soc3") }}
                </div>
            </div>
        </div>

        <Form />
    </div>
</template>
<script>
import SubHeader from "@/components/SubHeader.vue";
import Form from "./Form.vue";
import initAnimation from "../animation";
export default {
    data() {
        return {
            img: require("@/assets/images/sub_page_banner_10.jpg"),
            st: {
                backgroundImage:
                    "url(" +
                    require("@/assets/images/technology-4-Support-img-1-en.jpg") +
                    ")",
            },
            st1: {
                backgroundImage:
                    "url(" +
                    require("@/assets/images/technology-4-Support-img-1-cn.jpg") +
                    ")",
            },
            lang: localStorage.getItem("lang"),
        };
    },
    components: {
        SubHeader,
        Form,
    },
    mounted() {
        setTimeout(initAnimation, 0);
        this.$bus.$on("lang", (lang) => (this.lang = lang));
    },
};
</script>
<style scoped>
.bg {
    height: 663px;
    background-size: 1173px 479px;
    background-position: center right;
    background-repeat: no-repeat;
}
.cont {
    width: 1200px;
    margin: auto;
    overflow: hidden;
}
.cont-title {
    font-size: 44px;
    color: #000000;
    font-weight: bold;
    line-height: 66px;
    margin-top: 182px;
}
.cont-text {
    font-size: 16px;
    color: #333333;
    line-height: 34px;
    margin-top: 108px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Support/Support.vue